export default __webpack_public_path__ + "v1.18.25/static/media/libreView-ar.3cf809db.svg";